import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_FORMS } from "../domain";

import { formsApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_CREATE_FORM = "CREATE_FORM";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const lockForm = async (formId: string): Promise<void> => {
  const response = await formsApi.formsControllerLockForm(formId);

  return response.data;
};

export const useLockForm = (
  user: UserProfileDto | null,
): {
  lockForm: UseMutateFunction<void, Error, string, unknown>;
  lockFormEnabled: boolean;
  isSuccessLockForm: boolean;
  isPendingLockForm: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_FORMS],
    mutationFn: enabled ? lockForm : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DOMAIN_FORMS] });
    },
  });

  return {
    lockForm: mutate,
    lockFormEnabled: enabled,
    isSuccessLockForm: isSuccess,
    isPendingLockForm: isPending,
  };
};
